import React from 'react';
import { DAPrice } from '@components';

const PegDAPrice = () => {
  return (
    <DAPrice
      title="PEG DA Prices"
      rootPath="/media/files/csv/index/peg/"
      breadcrumbRootLabel="peg-da-prices"
      downloadProduct="PEG"
      downloadType="da_index"
      searchPlaceholders={{
        0: 'Search currency folder (e.g. EUR)',
        1: 'Search year folder (e.g. 2026)',
        2: 'Search month folder (e.g. 03 or March)',
        3: 'Search filename (e.g. 01.03.2026.csv)',
        default: 'Search filename or date'
      }}
      levelLabels={{
        0: 'Currency',
        1: 'Year',
        2: 'Month',
        3: 'File',
        default: 'Folder'
      }}
    />
  );
};

export default PegDAPrice;
